<template>
  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 product-item-container">
    <div class="product-item" @click="handleClick">
      <img ref="img" :src="item.src" :alt="item.text" />
      <p>{{ item.text }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item"],
  methods: {
    handleClick() {
      this.$router.push({
        path: `/productPresentation/${this.item.path}`,
      });
    },
  },
};
</script>
<style scoped>
img {
  width: 68px;
  height: 68px;
}
.product-item {
  width: 100%;
  height: 150px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.product-item > p {
  font-size: 12px;
  font-weight: 600;
  color: #353535;
  margin-top: 5px;
}
.product-item-container {
  width: 100%;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/product/ProductItemImg.vue